import { PROJECT_DG } from 'modules/constants';

export default function showTocTab(projectId) {
    return projectId !== PROJECT_DG;
}
